import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { createContest } from 'api/concourse';
//components
import Title from 'components/backoffice/texts/title';
import ContestForm from 'components/backoffice/forms/contestForm';

const contest = {
  name: '',
  client: null,
  user_special: null,
  discount: '',
  user_library: null,
}

const CreateContest = () => {
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setTitle } = useOutletContext();

  useEffect(() => {
    setTitle(t('createNewcontest'));
    return () => {
      setTitle('');
    };
  }, [setTitle]);

  const onSubmit = useCallback(async (values) => {
    setLoading(true)

    const libraryUsersIdsArray = values.user_library.map((user) => user.value);
    const { name, client, user_special, discount } = values;
    let data = {
      name: name,
      client: client?.value,
      user_special: user_special?.value,
      discount: parseInt(discount),
      user_library: libraryUsersIdsArray,
    };
    try {
      const response = await createContest(data);
      const { status, data: responseData } = response;
      if (responseData?.name?.[0] === "There is already a concourse with that name") {
        toast.error(t('nameContestAlreadyExists'), { theme: 'colored' });
        setLoading(false);
        return;
      }
      if ([200, 201].includes(status)) {
        toast.success(t('creadocorrectamente'));
        navigate('/intranet/contests', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log('error createContest', error);
    }
    setLoading(false)
  }, []);

  return (
    <div>
      <Title text={t('createNewcontest')} />
      <ContestForm
        loading={loading}
        isEditing={false}
        onSubmitForm={onSubmit}
        defaultValues={contest}
      />
    </div>
  );
};

export default CreateContest;
